import { rem } from 'polished';
import styled from 'styled-components';

export const StyledHeader = styled.header`
  position: sticky;
  top: 0;
  right: 0;
  left: 0;
  display: flex;
  height: ${rem('83px')};
  z-index: ${({ theme }) => theme.layers.header};
  background-color: ${({ theme }) => theme.colors.main};
`;

export const StyledLogoWrapper = styled.div`
  width: ${rem('110px')};
`;
